import script from "./CounsellingView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CounsellingView.vue?vue&type=script&lang=ts&setup=true"

import "./CounsellingView.vue?vue&type=style&index=0&id=2ea5c2e0&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea5c2e0"]])

export default __exports__